import React from 'react'
import './index.less'
import { goIndex } from './../../../assets/js/utils'
function BusinessTemplate (props) {
    const { buriedPointEvent, data: { position, sublist = [], trackId }, encryptionStatus } = props
    return (
        <React.Fragment>
            <ul className="BusinessTemplateBox">
                {sublist.map((item, index) => (
                    <li
                        className="content_lie"
                        key={item.id + ''}
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${trackId}-${item.title}`,
                                button_id: `${item.id}`,
                                button_order: `${index + 1}`,
                                area_order: position,
                                button_area: `${position}-${trackId}`
                            })
                            goIndex(item.url, trackId, item.keyword)
                        }}
                    >
                        {(index + 1) % 3 !== 0 ? (
                            <span className="content_lie_tips"></span>
                        ) : null}
                        <p className="content_title">{item.title}</p>
                        {item.flag === '1' ? (
                            <React.Fragment>
                                <p className="content_amount">
                                    {encryptionStatus ? '****' : item.amount}
                                </p>

                                {item.details.length > 0 ? (
                                    <React.Fragment>
                                        {item.details.map((k, j) => (
                                            <p className="content_earnings" key={j}>
                                                {k.title} {encryptionStatus ? '****' : k.value}
                                            </p>
                                        ))}
                                    </React.Fragment>
                                ) : (
                                    <p className="content_earnings">--</p>
                                )}
                            </React.Fragment>
                        ) : null}
                        {item.flag === '0' ? (
                            <React.Fragment>
                                <p className="content_amount">{item.introduce}</p>
                                <p className="content_earnings">{item.activeExplain}</p>
                            </React.Fragment>
                        ) : null}
                    </li>
                ))}
            </ul>
        </React.Fragment>
    )
}
export default BusinessTemplate
